import format from 'date-fns/format';

export const formatMessageTime = (datetime) => format(datetime, 'dd MMM HH:mm');
